import React, { useState} from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import UserProdFollow from "../../pages/lakayUser/userProdFollow";
import CateryName from "../../pageInside/cateryName";
import PubProducts from "../../pages/lakayUser/pubProduct";
import PageEmptySpace from "../../pageInside/pageEmptySpace";

import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";

import {
  Keyboard,
  Scrollbar,
  Navigation,
  Pagination,
  Virtual,
} from "swiper/modules";

const SwiperCatUserProd = (props) => {
  const {
    nbrArr = 3,
    title = "Your Follow Shop",
    infoSource,
    myStyles,
    wm0 = 2,
    wm640 = 2,
    wm768 = 3,
    wm1024 = 3,
    wm1200 = 3,
    // shop user categories
    userID,
    pubCategoryProd,
    shop = false,
    inView = false,
    setSearch,
    setCi,
    setShopUser,
    getShopName,
  } = props;

  const [imageHeight, setImageHeight] = useState(0);
const dataEmptyPage = ()=>{
  const min = 1;
  const max = 15;
  const a  = Math.floor(Math.random() * (max - min + 1)) + min;
  if (a === 1) {
    return {
      slogan: "Elakay works for",
      text: ["Art Lovers", "Trend Seekers", "Explorers", "YOU!"]
    };
  } else if (a === 2) {
    return {
      slogan: "Elakay empowers",
      text: ["Shoppers", "Supporters", "Smart Shoppers", "YOU!"]
    };
  } else if (a === 3) {
    return {
      slogan: "Elakay is for",
      text: ["Dreamers", "Makers", "Believers", "YOU!"]
    };
  } else if (a === 4) {
    return {
      slogan: "Elakay connects",
      text: ["Creators", "Explorers", "Innovators", "YOU!"]
    };
  } else if (a === 5) {
    return {
      slogan: "Elakay supports",
      text: ["Hustlers", "Visionaries", "Builders", "YOU!"]
    };
  } else if (a === 6) {
    return {
      slogan: "Elakay celebrates",
      text: ["Artists", "Designers", "Crafters", "YOU!"]
    };
  } else if (a === 7) {
    return {
      slogan: "Elakay unites",
      text: ["Communities", "Cultures", "Crafts", "YOU!"]
    };
  } else if (a === 8) {
    return {
      slogan: "Elakay inspires",
      text: ["Trendsetters", "Bargain Hunters", "Style Seekers", "YOU!"]
    };
  } else if (a === 9) {
    return {
      slogan: "Elakay fuels",
      text: ["Fashionistas", "Foodies", "Tech Enthusiasts", "YOU!"]
    };
  } else if (a === 10) {
    return {
      slogan: "Elakay is for",
      text: ["Collectors", "Curators", "Creators", "YOU!"]
    };
  } else if (a === 11) {
    return {
      slogan: "Elakay empowers",
      text: ["Adventurers", "Storytellers", "Visionaries", "YOU!"]
    };
  } else if (a === 12) {
    return {
      slogan: "Elakay connects",
      text: ["Stylists", "Homebodies", "Wanderers", "YOU!"]
    };
  } else if (a === 13) {
    return {
      slogan: "Elakay celebrates",
      text: ["Givers", "Receivers", "Believers", "YOU!"]
    };
  } else if (a === 14) {
    return {
      slogan: "Elakay is for",
      text: ["Leaders", "Thinkers", "Doers", "YOU!"]
    };
  } else if (a === 15) {
    return {
      slogan: "Elakay supports",
      text: ["Innovators", "Entrepreneurs", "Visionaries", "YOU!"]
    };
  } else {
    return {
      slogan: "Elakay works for",
      text: ["Art Lovers", "Trend Seekers", "Smart Shoppers", "YOU!"]
    };
  }
}
  const user_id = (u) => (u._id._id ? u._id._id : u._id);
  const classSlider = props.classSlider ? props.classSlider : "styles.sliderProduct";

  return (
    <div className={`mt-4 p-2 ${classSlider}`} style={myStyles}>
      <div>
        <span className="h5">{inView && title}</span>
      </div>

      <Swiper
        style={{
          "--swiper-navigation-color": "#007399",
          "--swiper-pagination-color": "#007399",
        }}
        cssMode
        slidesPerView={wm0}
        spaceBetween={10}
        slidesPerGroup={2}
        centeredSlides={false}
        slidesPerGroupSkip={1}
        grabCursor
        keyboard={{ enabled: true }}
        breakpoints={{
          568: { slidesPerView: wm640, spaceBetween: 10 },
          768: { slidesPerView: wm768, spaceBetween: 10 },
          1024: { slidesPerView: wm1024, spaceBetween: 10},
          1200: { slidesPerView: wm1200, spaceBetween: 10},
        }}
        scrollbar
        navigation={infoSource && infoSource.navigation}
        mousewheel
        pagination={{ clickable: true }}
        modules={[Keyboard, Scrollbar, Pagination, Navigation, Virtual]}
        className="mySwiper"
      >
        {shop
          ? /** ---------- CATEGORY MODE ---------- */
          (() => { 
            const slides = [];

            pubCategoryProd?.map((items, i) => (
              slides.push( <SwiperSlide key={`cat-${i}`}>
                <div className="card" style={{ textAlign: "left" }}>
                  <CateryName items={items} />
                  <PubProducts
                    infoSource={infoSource}
                    setShopUser={setShopUser}
                    getShopName={getShopName}
                    userID={userID}
                    categoryID={user_id(items)}
                  />
                 
                  <h6 className="ps-3">
                    {inView ? (
                      <button
                       class="btn btn-link m-0, p-1"
                        onClick={() => {
                          setCi(user_id(items), items.cateryName);
                          setSearch("");
                        }}
                      >
                        {infoSource.language(infoSource, "Link", "seeMore")}
                      </button>
                    ) : (
                      <Link
                        to={`/lakay-ShopSeller/${userID}?ci=${user_id(items)}`}
                      >
                        {infoSource.language(infoSource, "Link", "seeMore")}
                      </Link>
                    )}
                  </h6>
                </div>
              </SwiperSlide>
              )
            ))

            const fillers = Math.max(0, nbrArr - pubCategoryProd.length);

            for (let f = 0; f < fillers; f += 1) {
              slides.push(
                <SwiperSlide key={`filler-${f}`}>
                  <div className="card" style={{ width: '100%', textAlign: "left" }}>
                  <div
             style={{ aspectRatio: '1',  width: '100%'}}
                   >  
                    <div className="ps-2" style={{width: "100%", backgroundColor: '#DCDCDC', fontSize:'80%'}}>
                        <Link>.</Link>
                         </div>
                    <PageEmptySpace
                    data = {dataEmptyPage()}
                    classEmpty = {'AppPageEmptySpace'+ (Math.floor(Math.random() * (6 - 0 + 1)) + 0)}
                    />
                  </div>
                  </div> 
                </SwiperSlide>
              );
            }

            return  slides;
          })()
          : /** ---------- FOLLOW‑SHOP MODE ---------- */
          (() => {
              const slides = [];

              /* 1. real followed shops */
              const followed =
                infoSource?.userInfo?.followShopUser ?? [];

              followed.forEach((shopUser, idx) =>
                slides.push(
                  <SwiperSlide key={`follow-${idx}`}>
                    <UserProdFollow
                      infoSource={infoSource}
                      userID={shopUser._id}
                     
                    />
                  </SwiperSlide>
                )
              );

              /* 2. filler slides when length < 3 */
              const cards = [1, 2, 3, 4];
              const minSlides = 3;
              const fillers = Math.max(0, nbrArr - followed.length);

              for (let f = 0; f < fillers; f += 1) {
                slides.push(
                  <SwiperSlide key={`filler-${f}`}>
                    <div className="card" style={{ width: '100%', textAlign: "left" }}>
                    <div
               style={{ aspectRatio: '1',  width: '100%'}}
                     >  
                      <div className="ps-2" style={{width: "100%", backgroundColor: '#DCDCDC', fontSize:'80%'}}>
                          <Link>.</Link>
                           </div>
                      <PageEmptySpace
                      data = {dataEmptyPage()}
                      classEmpty = {'AppPageEmptySpace'+ (Math.floor(Math.random() * (6 - 0 + 1)) + 0)}
                      />
                    </div>
                    </div> 
                  </SwiperSlide>
                );
              }

              return  slides;
            })()
            }
      </Swiper>
    </div>
  );
};

export default SwiperCatUserProd;
